import axios from 'axios';

import { getPricingHeaders, SiteSettings } from '@gn-audio/jss-core';

import { logServerError } from 'utils/logger';

export const getCurrencyFormats = async (
  siteSettings: SiteSettings,
  language: string
): Promise<FormatSettings | undefined> => {
  if (!siteSettings.ecom?.ecomEnabled) return undefined;
  try {
    const globalSettingsUrl = `${siteSettings.sfcc?.shopApiBaseUrl}/custom_objects/GLOBALE_APP_SETTINGS/Globale`;
    const currencySymbolUrl = `${siteSettings.sfcc?.shopApiBaseUrl}//custom_objects/GLOBALE_CURRENCIES/${siteSettings.sfcc?.currency}`;
    const requestOptions = await getPricingHeaders(siteSettings.sfcc?.shopApiClientId);
    const {
      data: { c_serverSettings },
    } = await axios.get(globalSettingsUrl, requestOptions);
    const {
      data: { c_symbol },
    } = await axios.get(currencySymbolUrl, requestOptions);

    const serverSettings = JSON.parse(c_serverSettings);
    const currencySettings: CurrencySettingsParsed[] = JSON.parse(
      serverSettings.PriceDisplayFormat_CurrencySymbol.Value
    );
    const decimalSeparators: DecimalSeparatorParsed[] = JSON.parse(
      serverSettings.PriceDisplayFormat_DecimalSeparator.Value
    );
    const thousandSeparators: ThousandSeparatorParsed[] = JSON.parse(
      serverSettings.PriceDisplayFormat_ThousandSeparator.Value
    );

    const [, country = 'US'] = language.split('-');

    const currencySetting = currencySettings.find(
      (currency) => currency.CountryCode === country.toUpperCase()
    );
    const decimalSeparator = decimalSeparators.find(
      (decSeparator) => decSeparator.CountryCode === country.toUpperCase()
    )?.DecimalSeparator;
    const thousandSeparator = thousandSeparators.find(
      (thousandSeparator) => thousandSeparator.CountryCode === country.toUpperCase()
    )?.ThousandSeparator;

    const placeCurrencySymbolBeforePrice = currencySetting?.PlaceCurrencySymbolBeforePrice;
    return {
      placeCurrencySymbolBeforePrice: !!placeCurrencySymbolBeforePrice,
      useCurrencySymbolSpace: !!currencySetting?.UseCurrencySymbolSpace,
      currencyCode: siteSettings.sfcc?.currency,
      thousandSeparator: thousandSeparator ?? ',',
      decimalSeparator: decimalSeparator ?? '.',
      currencySymbol: c_symbol,
    };
  } catch (error) {
    logServerError(error);
    return undefined;
  }
};

export interface FormatResponse {
  c_serverSettings: SystemSettingsParsed;
}

export interface SystemSettingsParsed {
  PriceDisplayFormat_CurrencySymbol: { Value: CurrencySettingsParsed[] };
  PriceDisplayFormat_DecimalSeparator: { Value: DecimalSeparatorParsed[] };
  PriceDisplayFormat_ThousandSeparator: { Value: ThousandSeparatorParsed[] };
}
export interface CurrencySettingsParsed {
  CountryCode: string;
  PlaceCurrencySymbolBeforePrice: string;
  UseCurrencySymbolSpace: string;
}

export interface DecimalSeparatorParsed {
  CountryCode: string;
  DecimalSeparator: string;
}

export interface DecimalSeparatorParsed {
  CountryCode: string;
  DecimalSeparator: string;
}

export interface ThousandSeparatorParsed {
  CountryCode: string;
  ThousandSeparator: string;
}

export interface FormatSettings {
  currencySymbol: string;
  placeCurrencySymbolBeforePrice: boolean;
  useCurrencySymbolSpace: boolean;
  decimalSeparator: string;
  thousandSeparator: string;
  currencyCode?: string;
}
